module.exports = __webpack_public_path__ + "img/92107.359199c0.svg";